// extracted by mini-css-extract-plugin
module.exports = {"header":"MilestonesPage_header__1TsUw","navigationWrapper":"MilestonesPage_navigationWrapper__3KtP3","cardWrapper":"MilestonesPage_cardWrapper__A4zI3"};